<template>
    <iframe allowfullscreen
            :src="`${widgetUrl}/?${widgetQuery}`"
            allow="camera;microphone"
            class=""
            id="botter-iframe">
    </iframe>
</template>

<script>
  import common from "../../utils/common";

  export default {
    name: "chatPlugin",
    data() {
      return {
        widgetQuery: ''
      }
    },
    mounted() {
      this.loadWidget()
    },
    beforeMount() {

    },
    methods: {
        loadWidget () {
          let widgetParameters = localStorage.getItem(`widgetSettings-${this.$store.state.bot.botId}`)
          widgetParameters = JSON.parse(widgetParameters)
          if (widgetParameters) {
            widgetParameters.demoBackground = ''
            widgetParameters.position = 'right'
          }

          let query = `bot_id=${this.$store.state.bot.botId}&iframe-dashboard=true`
          if (widgetParameters) {
            query += '&'
            query +=  common.serialize(widgetParameters)
          }
          this.widgetQuery = query

          window.onload = ()=> {
            let myiFrame = document.getElementById("widget-iframe-test");
            let doc = myiFrame.contentDocument;
            doc.body.innerHTML = doc.body.innerHTML + '<style> .botter-widget-body {background-image: none !important;}</style>';

          }
        }
    },
    computed: {
      displayWidget() {
        return this.$router.currentRoute.path !== '/publish'
      },
      widgetUrl () {
        return process.env.VUE_APP_WIDGET_IFRAME_URL
      },
      botId() {
        return this.$store.state.bot.botId
      }
    },
    watch: {
      botId() {
        let wn = document.getElementById('botter-iframe').contentWindow;
        this.loadWidget()
        wn.postMessage({
          type: 'reload',
          value: true
        }, '*');
      }
    }
  }
</script>

<style >
    .botter-widget-body {
        background-image: none !important;
    }
</style>
